module.exports = __webpack_public_path__ + "img/aej1n-66wvl.014.a419d6c1.png";